export default __webpack_public_path__ + "static/media/16.6687d9a9.jpeg";